import React from "react";
import { IIcons } from "./icons";

const UpCircleIcon = ({ fillColor }: IIcons.IconProps) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // className={fillColor}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.95886 12.9104C2.95886 20.3737 5.44732 22.8621 12.9105 22.8621C20.3738 22.8621 22.8622 20.3737 22.8622 12.9104C22.8622 5.4472 20.3738 2.95874 12.9105 2.95874C5.44732 2.95874 2.95886 5.4472 2.95886 12.9104Z"
        stroke="#A3AED0"
        strokeWidth="1.13914"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={fillColor}
      />
      <path
        d="M9.17554 15.1096C9.17554 15.1096 11.749 11.3591 12.9109 11.3591C14.0728 11.3591 16.6441 15.1096 16.6441 15.1096"
        stroke="#A3AED0"
        strokeWidth="1.13914"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={fillColor}
      />
    </svg>
  );
};

export default UpCircleIcon;
